module.exports = __webpack_public_path__ + "static/img/mine.fa5d25b1.png";